import React from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { getResumeUrl } from "../content/assets";
import { contact, getCopy } from "../content/portfolio";

function localizedPath(pathname, locale, hash = "") {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] === "de" || segments[0] === "en") segments[0] = locale;
  else segments.unshift(locale);
  return `/${segments.join("/")}${pathname.endsWith("/") ? "/" : ""}${hash}`;
}

export default function SiteLayout() {
  const { locale = "de" } = useParams();
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const copy = getCopy(locale);
  const prefix = `/${locale}`;
  const navItems = [
    [copy.nav.home, `${prefix}/`],
    [copy.nav.projects, `${prefix}/projects/`],
    [copy.nav.capabilities, `${prefix}/capabilities/`],
    [copy.nav.contact, `${prefix}/contact`]
  ];
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  function isCurrent(to) {
    const normalizedTarget = to.replace(/\/+$/, "");
    if (normalizedTarget === prefix) return normalizedPath === prefix;
    if (normalizedTarget.endsWith("/projects")) return normalizedPath === normalizedTarget || normalizedPath.startsWith(`${normalizedTarget}/`);
    return normalizedPath === normalizedTarget;
  }
  return (
    <>
      <a className="skip-link" href="#main-content">{locale === "de" ? "Zum Inhalt springen" : "Skip to content"}</a>
      <header className="site-header">
        <nav className="site-nav" aria-label={locale === "de" ? "Hauptnavigation" : "Main navigation"}>
          <Link className="site-brand h4" to={`${prefix}/`}>Anton Rost // QA</Link>
          <div className="site-nav-links">
            {navItems.map(([label, to]) => <Link key={to} className="bodycopy" to={to} aria-current={to.includes("#") ? (hash === `#${to.split("#")[1]}` ? "location" : undefined) : (isCurrent(to) ? "page" : undefined)}>{label}</Link>)}
            <a className="bodycopy" href={getResumeUrl(locale)} target="_blank" rel="noreferrer" aria-label={`${copy.nav.resume} ${locale === "de" ? "(öffnet in einem neuen Tab)" : "(opens in a new tab)"}`}>{copy.nav.resume}</a>
          </div>
          <div className="locale-switcher" role="group" aria-label={locale === "de" ? "Sprache wechseln" : "Change language"}>
            {["de", "en"].map(language => (
              <button
                key={language}
                type="button"
                className="locale-option"
                lang={language}
                aria-pressed={locale === language}
                onClick={() => navigate(localizedPath(pathname, language, hash))}
              >
                {language.toUpperCase()}
              </button>
            ))}
          </div>
        </nav>
      </header>
      <main id="main-content" tabIndex="-1"><Outlet /></main>
      <footer className="site-footer">
        <div className="site-footer-inner">
          <p className="site-footer-meta bodycopy">© {new Date().getFullYear()} {copy.footer}</p>
          <nav className="site-footer-nav" aria-label={locale === "de" ? "Fußnavigation" : "Footer navigation"}>
            <a className="bodycopy" href={`mailto:${contact.email}`}>{contact.email}</a>
            <Link className="bodycopy" to={`${prefix}/privacy`}>{locale === "de" ? "Datenschutz" : "Privacy"}</Link>
            <Link className="bodycopy" to={`${prefix}/legal`}>{locale === "de" ? "Impressum" : "Legal"}</Link>
          </nav>
        </div>
      </footer>
    </>
  );
}
